import React from 'react';
import Typography from '@mui/material/Typography';

// css

const SplitRowText = props => {
  const { textArray } = props;

  return (
    <>
      {textArray.map((txt, index) =>
        <Typography key={index} >
          {txt !== undefined && txt !== null && txt !== '' ? txt : ' - '}
        </Typography>
      )}
    </>
  );
};

export default SplitRowText;
